import axios from "axios";
import { message } from "antd";

export const errorHandler = (err)=>{
    if(axios.isAxiosError(err)){
        message.error(`${err.response.status} ${err.response.statusText}: ${err.response.data}`);
    }else{
        message.error(err.message);
    }
}